module.exports = __webpack_public_path__ + "static/WpK_lazienka_pakiet_platynowy-560ee188d84502309574fe280cdce410.jpg";